document.addEventListener("DOMContentLoaded", function() {
  bindCustomProductCardVariantChange();
});

function bindCustomProductCardVariantChange() {
  const customProductCardVariants = document.querySelectorAll('.custom-product-card-product-price-dropdown');
  if (customProductCardVariants.length) {
    customProductCardVariants.forEach(function(customProductCardVariant) {
      customProductCardVariant.addEventListener('change', function() {
        const targetProductVariantId = this.value;
        const targetProductVariant = this.options[this.selectedIndex];
        const targetProductVariantAvailability = targetProductVariant.getAttribute('data-available');
        const targetProductcard = this.closest('.custom-product-card-wrapper');
        if (targetProductcard) {
          const targetAddToCartForm = targetProductcard.querySelector('form');
          if (targetAddToCartForm) {
            const targetAddToCartFormIdElement = targetAddToCartForm.querySelector('[name="id"]');
            if (targetAddToCartFormIdElement) {
              targetAddToCartFormIdElement.value = targetProductVariantId;
              targetAddToCartFormIdElement.disabled = false;
            }

            const targetAddToCartFormAddElement = targetAddToCartForm.querySelector('[name="add"]');
            if (targetAddToCartFormAddElement) {
              targetAddToCartFormAddElement.disabled = false;
            }

            const targetAddToCartBtnMsg = targetAddToCartForm.querySelector('.custom-product-card-add-to-cart-button-message');
            if (targetAddToCartBtnMsg) {
              targetAddToCartBtnMsg.innerHTML = targetAddToCartBtnMsg.getAttribute("data-add-to-cart") || "Add to cart";
            }

            if (targetProductVariantAvailability != "true") {
              if (targetAddToCartFormIdElement) {
                targetAddToCartFormIdElement.disabled = true;
              }

              if (targetAddToCartFormAddElement) {
                targetAddToCartFormAddElement.disabled = true;
              }

              if (targetAddToCartBtnMsg) {
                targetAddToCartBtnMsg.innerHTML = targetAddToCartBtnMsg.getAttribute("data-sold-out") || "Sold out";
              }
            }
          }
        }
      });
    });
  }
}

// document.addEventListener("DOMContentLoaded", function () {
//   const customSelectWrappers = document.querySelectorAll(".custom-select-wrapper");
//   //console.log(document.querySelectorAll(".custom-select-wrapper").length);
//   customSelectWrappers.forEach(wrapper => {
//     const customSelected = wrapper.querySelector(".custom-selected");
//     const customOptions = wrapper.querySelector(".custom-options");
//     const options = wrapper.querySelectorAll(".custom-option");
//     const hiddenSelect = wrapper.querySelector(".custom-product-card-product-price-dropdown");

//     if (options.length > 0) {
//       const firstOption = options[0];
//       firstOption.classList.add("selected");
//       const variantTitle = firstOption.querySelector("p") ? firstOption.querySelector("p").innerHTML : firstOption.textContent.trim();
//       const originalPrice = firstOption.querySelector(".original-price") ? firstOption.querySelector(".original-price").outerHTML : "";
//       const salePrice = firstOption.querySelector(".sale-price") ? firstOption.querySelector(".sale-price").outerHTML : "";
//       customSelected.innerHTML = `
//         <p>${variantTitle }</p>
//         ${originalPrice}
//         ${salePrice}
//       `;
//       //
//       hiddenSelect.value = firstOption.getAttribute("data-value");
//       hiddenSelect.dispatchEvent(new Event("change"));
//     }

//     customSelected.addEventListener("click", (event) => {
//       event.stopPropagation();
//       customOptions.classList.toggle("open");
//     });

//     options.forEach(option => {
//       option.addEventListener("click", (event) => {
//         event.stopPropagation();
//         options.forEach(opt => opt.classList.remove("selected"));
//         option.classList.add("selected");


//         const variantTitle = option.querySelector("p").innerHTML;
//         const originalPrice = option.querySelector(".original-price") ? option.querySelector(".original-price").outerHTML : "";
//         const salePrice = option.querySelector(".sale-price") ? option.querySelector(".sale-price").outerHTML : "";

//         customSelected.innerHTML = `
//           <p>${variantTitle}</p>
//           ${originalPrice}
//           ${salePrice}
//         `;
//         hiddenSelect.value = option.getAttribute("data-value");
//         hiddenSelect.dispatchEvent(new Event("change"));
//         customOptions.classList.remove("open");
//       });
//     });
//   });

//   document.addEventListener("click", function (e) {
//     customSelectWrappers.forEach(wrapper => {
//       const customOptions = wrapper.querySelector(".custom-options");
//       //if (!e.target.closest(".custom-select-wrapper")) {
//         customOptions.classList.remove("open");
//       //}
//     });
//   });
// });

(() => {
  // Keep track of which wrappers we've already initialized
  const initialized = new WeakSet();

  // Initialization logic for a single wrapper
  function initCustomSelect(wrapper) {
    if (initialized.has(wrapper)) return;
    initialized.add(wrapper);

    const customSelected = wrapper.querySelector(".custom-selected");
    const customOptions  = wrapper.querySelector(".custom-options");
    const options        = wrapper.querySelectorAll(".custom-option");
    const hiddenSelect   = wrapper.querySelector(".custom-product-card-product-price-dropdown");

    // Helper to update the "selected" display
    function updateSelected(optionEl) {
      options.forEach(o => o.classList.remove("selected"));
      optionEl.classList.add("selected");

      const variantTitle = optionEl.querySelector("p")?.innerHTML.trim() || optionEl.textContent.trim();
      const originalPrice = optionEl.querySelector(".original-price")?.outerHTML || "";
      const salePrice     = optionEl.querySelector(".sale-price")?.outerHTML     || "";

      customSelected.innerHTML = `
        <p>${variantTitle}</p>
        ${originalPrice}
        ${salePrice}
      `;

      hiddenSelect.value = optionEl.getAttribute("data-value");
      hiddenSelect.dispatchEvent(new Event("change"));
    }

    // Pre-select first option if any
    if (options.length > 0) {
      updateSelected(options[0]);
    }

    // Toggle dropdown on header click
    customSelected.addEventListener("click", e => {
      e.stopPropagation();
      customOptions.classList.toggle("open");
    });

    // Handle clicks on each option
    options.forEach(opt => {
      opt.addEventListener("click", e => {
        e.stopPropagation();
        updateSelected(opt);
        customOptions.classList.remove("open");
      });
    });
  }

  // Initialize any currently existing wrappers
  function scanAndInit() {
    document
      .querySelectorAll(".custom-select-wrapper")
      .forEach(initCustomSelect);
  }

  // Close all dropdowns when clicking outside
  document.addEventListener("click", () => {
    document
      .querySelectorAll(".custom-select-wrapper .custom-options.open")
      .forEach(menu => menu.classList.remove("open"));
  });

  // Run on DOM ready
  if (document.readyState !== "loading") {
    scanAndInit();
  } else {
    document.addEventListener("DOMContentLoaded", scanAndInit);
  }

  // Observe for new wrappers inserted later
  const mo = new MutationObserver(mutations => {
    for (let { addedNodes } of mutations) {
      addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        // If a new wrapper itself was added...
        if (node.matches(".custom-select-wrapper")) {
          initCustomSelect(node);
        }
        // Or if child wrappers were added somewhere under this node...
        node.querySelectorAll?.(".custom-select-wrapper")
            .forEach(initCustomSelect);
      });
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree:   true
  });
})();
